import React from 'react';
import styles from '../styles';
import { IconButton, IconTextButton } from '@xpertdox_js/xdcomponents';
import {btn_c_xdHighlight, btn_c_clearToShade} from '@xpertdox_js/xdstyle';
import OriginalContentData from '../Panels/OriginalContentData';
import PatientView from '../Panels/PatientView';
import AllContent from '../Panels/AllContent'
import TrialConfiguration from '../Panels/TrialConfiguration';
import Filters from '../Panels/Filters';
import PrescreenQuestions from "../Panels/PrescreenQuestions";
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'
import LogsComponent from "../../Common/LogsComponent";
import Conditions from "../Panels/Conditions";

export default (args) => {
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  if (!args) return null;
  const {handleSave, diffRef, setDiff, filters, id, childStore, setChildStore, overviewData, allNctsToPass, history, match} = args;
  const {diff} = diffRef.current;
  let currentNctIndex = allNctsToPass.indexOf(id);

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const handlePreviousNct = () => {
    if (currentNctIndex > 0) {
      let previousNct = allNctsToPass[currentNctIndex - 1];
      history.push({
        pathname: `/${match.params.instance}/trials/overview/${previousNct}`,
        state: history.location.state,
      });
    }
    handleActivityLogUpdate(`windowSettings.handlePreviousNct`)
  }

  const handleNextNct = () => {
    if (currentNctIndex < allNctsToPass.length - 1) {
      let nextNct = allNctsToPass[currentNctIndex + 1]
      history.push({
        pathname: `/${match.params.instance}/trials/overview/${nextNct}`,
        state: history.location.state,
      });
    }
    handleActivityLogUpdate(`windowSettings.handleNextNct`)
  }

  // -- window display widgets -- in tab above window display
  const tabWidget = (key) => {
    return <div style={styles.tabWidgetContainer}>
      {
        currentNctIndex !== undefined && currentNctIndex > 0
         ? <IconButton
              onClick={handlePreviousNct}
              styles={styles.btns}
              icon='arrowLeft'
              preBuiltStyles={btn_c_clearToShade}
              size='md'
            /> : null
      }
      <IconButton
        onClick={handleNextNct}
        styles={styles.btns}
        icon='arrowRight'
        preBuiltStyles={btn_c_clearToShade}
        size='md'
      />

      {Object.keys(diff).length > 0 &&
        <IconTextButton
          onClick={handleSave}
          styles={{...styles.btns, ...styles.saveBtn}}
          preBuiltStyles={btn_c_xdHighlight}
          key={key.id}
          icon='save'
          text='Save'
          size='md'
        />
      }
    </div>;
  }


  // -- dry vars
  const mainPanelWidth = document.body.clientWidth >= 1200 ? 65 : 70;
  const secondaryPanelWidth = document.body.clientWidth >= 1200 ? 35 : 30;
  const sharedMainPanelSettings = {widgets: {tab: tabWidget}, width: mainPanelWidth, window: 1};
  const sharedSecondaryPanelSettings = {window: 2, width: secondaryPanelWidth};
  const mainContentProps = {data: overviewData.trialData, editedLogs: overviewData.editedLogs, diff: diff, setDiff, nct: id}
  return ({
    // -> form/dynamic panels
    trialConfiguration :{
      title: 'Trial Overview',
      content: (width) => <TrialConfiguration {...mainContentProps}
        width={width}
        user={user}
      />,
      defaultWith: 'originalContent',
      ...sharedMainPanelSettings,
    },
    filters: {
      title: 'Filters',
      content: (width) => <Filters {...mainContentProps}
        diff={diffRef.current.diff} // have to pass diff again because updated diff was not recieved in Filters
        filters={filters}
        user={user}
        width={width}
      />,
      ...sharedMainPanelSettings,
      // defaultWith: 'originalData',
      defaultWith: 'originalContent'
    },
    patientView: {
      title: 'Simplified View',
      content: (width) => <PatientView {...mainContentProps}
        width={width}
        overviewForm={diff}
        setDiff={setDiff}
        nct={id}
        user={user}
        addedPIs={childStore.addedPIs}
        setAddedPIs={val => setChildStore('addedPIs', val)}
      />,
      ...sharedMainPanelSettings,
      defaultWith: 'originalContent',
    },
    prescreenData: {
      title: 'Prescreen Questions',
      content: (width) => <PrescreenQuestions {...mainContentProps}
        instanceSettings={overviewData.instanceSettings}
        width={width}
        user={user}
      />,
      ...sharedMainPanelSettings,
      defaultWith: 'originalContent'
    },
    conditions: {
      title: 'Conditions',
      content: () => <Conditions
        instance={contextInstance || user.instance}
        email={user.email}
        nct={id}
      />,
      ...sharedMainPanelSettings,
      defaultWith: 'originalContent'
    },
    // allView: {
    //   title: 'All',
    //   content: (width) => <AllContent
    //     {...mainContentProps}
    //     diff={diffRef.current.diff} // have to pass diff again because updated diff was not recieved in Filters
    //     filters={filters}
    //     user={user}
    //     width={width}
    //   />,
    //   ...sharedMainPanelSettings,
    //   defaultWith: 'originalContent',
    // },
    // -> static content panels
    originalContent: {
      title: 'Original Content',
      subTitle: 'from clinicaltrials.gov',
      content: () => <React.Fragment>
        <OriginalContentData data={overviewData.trialData} nctId={id} user={user} />
        <LogsComponent data={overviewData.logs} approvedLogs={overviewData.trialData.approvedLogs} nctId={id} user={user}/>
      </React.Fragment>,
      defaultWith: 'trialContent',
      ...sharedSecondaryPanelSettings
    }
  })
}
